import {
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_FAILED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_FAILED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_CANCELED,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_SET,
    REPORTS_HARVEST_INSPECTIONS_PEOPLE_MERGE,
    REPORTS_HARVEST_INSPECTION_SET
} from './constants';

export function requestLoadReportsHarvestInspectionsPeople() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_REQUESTED
    };
}

export function succeededLoadReportsHarvestInspectionsPeople(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReportsHarvestInspectionsPeople(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingReportsHarvestInspectionsPeople() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_REQUESTED
    };
}

export function succeededPollingReportsHarvestInspectionsPeople(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingReportsHarvestInspectionsPeople(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingReportsHarvestInspectionsPeople() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_POLLING_CANCELED
    };
}

export function setReportsHarvestInspectionsPeople(
    data: Record<string, any>[]
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_SET,
        payload: data,
        meta: {
            keyBy: 'personId'
        }
    };
}

export function mergeReportsHarvestInspectionsPeople(
    data: Record<string, any>[]
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_PEOPLE_MERGE,
        payload: data
    };
}

export function setReportsHarvestInspection(data: Record<string, any>) {
    return {
        type: REPORTS_HARVEST_INSPECTION_SET,
        payload: data
    };
}
